import { render, staticRenderFns } from "./ResourceClassificationInfo.vue?vue&type=template&id=6075c352&scoped=true"
import script from "./ResourceClassificationInfo.vue?vue&type=script&lang=js"
export * from "./ResourceClassificationInfo.vue?vue&type=script&lang=js"
import style0 from "./ResourceClassificationInfo.vue?vue&type=style&index=0&id=6075c352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075c352",
  null
  
)

export default component.exports